import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { FeederService } from '../../services/feeder.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-feederpopup',
  templateUrl: './feederpopup.component.html',
  styleUrls: ['./feederpopup.component.scss']
})
export class FeederpopupComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  state ;
  selected ;
  feederList ;
  dataSource;
  displayedColumns = ["FeederID", "SiteName", "KVARating", "LastUpdatedTime", "Status",];
  displayedColumnsAlert = ["FeederID", "SiteName", 'ParamName',"ActualValue", "ThresholdValue"];
  isTile: boolean = false;
  isTileData: boolean = true;
  isAlert: boolean = false;
  isAlertData: boolean = true; 
  responseData;
  alerts;

  constructor(@Inject(MAT_DIALOG_DATA) public data, private feederService: FeederService, public dialogRef: MatDialogRef<FeederpopupComponent>, private ngxLoader: NgxUiLoaderService) { }

  ngOnInit() {
    this.state = this.data.state;
    this.selected = this.data.selected;
    this.feederList = this.data.feederOptions;

    if(this.selected.toLowerCase() == 'tile'){
      this.isTile = true;
      this.isAlert = false;
      this.getTileData(this.state);
    } else if(this.selected.toLowerCase() == 'alert'){
      this.isAlert = true;
      this.isTile = false;
      this.getAlertTileData(this.state);
    }
  }

  async getTileData(state){
    this.ngxLoader.startLoader('tile');
    this.responseData = null;
    if(state.toLowerCase() == 'all'){
      await this.feederService.getFeederPopupTileData({'feederList': this.feederList, 'state': this.state}).subscribe((response:any) => {
        console.log("RESPONSE>>>>>>", response);
        if(response.data.length>0){
          this.isTileData = true;
          this.responseData = response.data
          this.dataSource = new MatTableDataSource(this.responseData);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          console.log('DataSource>>>>>>>',this.dataSource.filteredData);
        } else {
          this.isTileData = false;
        }
        this.ngxLoader.stopLoader('tile');
      });
    } else if(state.toLowerCase() == 'online'){
      await this.feederService.getFeederPopupTileData({'feederList': this.feederList, 'state':this.state}).subscribe((response:any) => {
        console.log("RESPONSE>>>>>>", response);
        if(response.data.length > 0){
          this.isTileData = true;
          this.responseData = response.data
        //dummyData = response.data;
          this.responseData.forEach(element => {
            if(element.alert.length > 0){
              element.status = 'alert'
            } else {
              element.status = 'online'
            }
          });
          console.log("Dummy Data>>>>>>", this.responseData);
          this.dataSource = new MatTableDataSource(this.responseData);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          console.log('DataSource>>>>>>>',this.dataSource);
        } else {
          this.isTileData = false;
        }
        this.ngxLoader.stopLoader('tile');
      });
    } else if(state.toLowerCase() == 'offline'){
      await this.feederService.getFeederPopupTileData({'feederList': this.feederList, 'state':this.state}).subscribe((response:any) => {
        console.log("RESPONSE>>>>>>", response);
        if(response.data.length > 0){
          this.isTileData = true;
          this.responseData = response.data;
          this.responseData.forEach(element => {
            element.status = 'offline';
          });
          console.log("Dummy Data>>>>>>", this.responseData);
          this.dataSource = new MatTableDataSource(this.responseData);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          console.log('DataSource>>>>>>>',this.dataSource);
          
        } else {
          this.isTileData = false;
        }
        this.ngxLoader.stopLoader('tile');
      });
    } else if(state.toLowerCase() == 'alert'){
      await this.feederService.getFeederPopupTileData({'feederList': this.feederList, 'state':this.state}).subscribe((response:any) => {
        console.log("RESPONSE>>>>>>", response);
        this.responseData = response.data;
          this.responseData = this.responseData.filter(element => {
            if (element.alert.length > 0) {
              element.status = 'alert';
              return true;
            } else {
              //element.status = 'online';
              return false;
            }
          });
          //this.responseData = this.responseData.filter(response => response.status.toLowerCase() === 'alert');
          if(this.responseData.length > 0){
            console.log("RESPONSE DATA>>>>>>", this.responseData);
            this.isTileData = true;
            console.log("Dummy Data>>>>>>", this.responseData);
            this.dataSource = new MatTableDataSource(this.responseData);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            console.log('DataSource>>>>>>>',this.dataSource);
            
          } else {
            this.isTileData = false;
          }
          this.ngxLoader.stopLoader('tile');
      });
    } else if(state.toLowerCase() == 'normal'){
      await this.feederService.getFeederPopupTileData({'feederList': this.feederList, 'state':this.state}).subscribe((response:any) => {
        console.log("RESPONSE>>>>>>", response);
        this.responseData = response.data;
        this.responseData = this.responseData.filter(element => {
          if(element.alert.length == 0 ){
            element.status = 'normal';
            return true;
          } else {
            return false;
          }
        });
        console.log("RESPONSE DATA>>>>>>", this.responseData);
        if(this.responseData.length > 0){
          this.isTileData = true;
          console.log("Dummy Data>>>>>>", this.responseData);
          this.dataSource = new MatTableDataSource(this.responseData);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          console.log('DataSource>>>>>>>',this.dataSource);
        } else {
          this.isTileData = false;
        }
        this.ngxLoader.stopLoader('tile');
      });
    } 
  }

  getAlertTileData(state){
    this.ngxLoader.startLoader('alert');
    this.dataSource = null;
    this.feederService.getFeederAlertTileData({'feederList': this.feederList, 'state': state}).subscribe((response:any) => {
      console.log('RESPONSE FROM ALERT TABLE >>>>>>', response);
      if(response.data.length > 0){
        this.isAlertData = true;
        this.dataSource = new MatTableDataSource(response.data); 
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        
      } else {
        this.isAlertData = false;
      }
      this.ngxLoader.stopLoader('alert');
    });
  }

  public doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  }

  close(){
    this.dialogRef.close();
  }

  alertdata(feederid){
    //console.log('On Hover');
    this.alerts = '';
    //console.log("ejkejdked....",switchid)
    this.responseData.forEach(element => { 
      if(element.id == feederid ){
        //console.log('element>>>>>',element);
        //console.log("THIS IS AN Alert")
        if(element.status.toLowerCase() == 'alert'){
          //console.log('ALERTS>>>>>', element.alert);
          for(var i =0; element.alert.length > i; i++){
            this.alerts += element.alert[i] + ', ';
          }
          //console.log('ALERTS>>>>>', this.alerts);
        }
      }
    });
  }

  getStatusColor(status: string): string {
    switch(status) {
        case 'online':
            return 'green';       // Red dot for online status
        case 'offline':
            return 'black';     // Black dot for offline status
        case 'normal':
            return 'green';      // Blue dot for normal status
        case 'alert':
            return 'red';       // Red dot for alert status
        default:
            return 'gray';      // Default fallback color
    }
  }


}
